import { Base, withMountWhenInView } from '@studiometa/js-toolkit';
import { animate } from 'motion';
import { inOutQuad } from '../utilities/easings.js';

/**
 * @typedef {object} ImmersiveVideoRef
 * @property {HTMLElement} video
 * @property {HTMLSourceElement} source
 * @property {HTMLElement[]} curtains[]
 */

/**
 * @typedef {object} ImmersiveVideoInterface
 * @property {ImmersiveVideoRef} $refs
 */

/**
 * Homepage class.
 */
export default class ImmersiveVideo extends withMountWhenInView(Base, { rootMargin: '50%' }) {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'ImmersiveVideo',
    refs: ['video', 'source', 'curtains[]'],
  };

  /**
   * Video mounted
   * @this    {Video & ImmersiveVideoInterface}
   * @returns {void}
   */
  async mounted() {
    this.$refs.source.src = this.$refs.source.dataset.src;

    // Play video
    this.$refs.video.pause();
    await this.$refs.video.load();
    await this.$refs.video.play();
  }

  /**
   * Animate then terminate instance on video loaded
   * @this    {Video & ImmersiveVideoInterface}
   * @returns {void}
   */
  onVideoLoadeddata() {
    // Open curtains
    this.$refs.curtains.forEach((curtain) => {
      animate(curtain, { scaleX: 0 }, { duration: 0.8, easing: inOutQuad });
    });

    // Terminate
    this.$terminate();
  }
}
